/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { FC } from 'react';

import { ReactComponent as CheckmarkEnclosedFilled } from 'src/public/ds/icons/checkmark-enclosed-filled.svg';
import { ReactComponent as Checkmark } from 'src/public/ds/icons/checkmark.svg';
import { ReactComponent as Chevron } from 'src/public/ds/icons/chevron.svg';
import { ReactComponent as Close } from 'src/public/ds/icons/close.svg';
import { ReactComponent as InfoEnclosedFilled } from 'src/public/ds/icons/info-enclosed-filled.svg';
import { ReactComponent as WarningEnclosedFilled } from 'src/public/ds/icons/warning-enclosed-filled.svg';
import { ReactComponent as XEnclosedFilled } from 'src/public/ds/icons/x-enclosed-filled.svg';
import { ReactComponent as TriangleDown } from 'src/public/ds/icons/triangle-down.svg';
import { ReactComponent as TriangleUp } from 'src/public/ds/icons/triangle-up.svg';
// to be removed, those icons were added only temporary to render mocked UI for the design team to click trough the app
import { ReactComponent as TemporaryForYouImage1 } from 'src/public/ds/temporary/for_you_1.svg';
import { ReactComponent as TemporaryForYouImage2 } from 'src/public/ds/temporary/for_you_2.svg';
import { ReactComponent as TemporaryForYouImage3 } from 'src/public/ds/temporary/for_you_3.svg';
import { ReactComponent as TemporaryWellbeingIcon } from 'src/public/ds/temporary/wellbeing_temporary.svg';
import { dsColors, DsColors } from 'src/shared/ds/variables';

const icons = {
    'temporary-for-you-image-1': TemporaryForYouImage1,
    'temporary-for-you-image-2': TemporaryForYouImage2,
    'temporary-for-you-image-3': TemporaryForYouImage3,
    'temporary-wellbeing-icon': TemporaryWellbeingIcon,

    checkmark: Checkmark,
    'checkmark-enclosed-filled': CheckmarkEnclosedFilled,
    'info-enclosed-filled': InfoEnclosedFilled,
    'warning-enclosed-filled': WarningEnclosedFilled,
    'x-enclosed-filled': XEnclosedFilled,
    'chevron-right': Chevron,
    close: Close,
    'triangle-up': TriangleUp,
    'triangle-down': TriangleDown,
};

export type Icons = keyof typeof icons;

export interface IconProps {
    name: Icons;
    className?: string;
    /**
     * Color: this can be either key of `color` object property or a hex string
     */
    color?: LiteralUnion<DsColors>;
    /**
     * Size: controls height and width of the Icon, default = 16
     */
    size?: number;
}

export const Icon: FC<IconProps> = ({
    name,
    className,
    color = dsColors.neutral200,
    size = 16,
}) => {
    const IconComponent = icons[name];
    return (
        <IconComponent
            className={className}
            data-testid={`${IconTestID.Icon}_${name}`}
            color={color[0] === '#' ? color : dsColors[color]}
            height={size}
            width={size}
        />
    );
};

export enum IconTestID {
    Icon = 'IconTestID.Icon',
}
